export default "__VITE_ASSET__CMlI4YHH__"